import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";

export class CPageHeight extends BasicCPCLArg<CPageHeight> {
  private height: number;
  private copies: number;

  constructor(options?: {
    /**
     * 打印区域高度
     */
    height?: number
    copies?: number
  }) {
    super();
    this.height = options?.height ?? 0;
    this.copies = options?.copies ?? 1;
  }

  clause(): CommandClause {
    return CPCLCommand.with(this.header())
      .appendNumber(this.height)
      .appendNumber(this.copies)
      .clause();
  }

  header(): string {
    return '! 0 200 200';
  }
}



